<div class="layout-topbar rtmenu">
  <a
    href="#"
    class="layout-menubutton"
    [ngClass]="{ 'layout-menubutton-active': app.menuActive }"
    (click)="app.onMenuButtonClick($event)">
    <div class="layout-menubutton-icon"></div>
  </a>

  <div class="layout-topbar-grid">
    <div class="layout-topbar-grid-column">
      <app-menu [reset]="app.resetMenu"></app-menu>
    </div>

    <div class="layout-topbar-grid-column layout-topbar-grid-column-fixed">
      @if (!authenticated) {
        <a
          href="#"
          class="profile-menu-button"
          (click)="app.onTopbarUserMenuButtonClick($event)"
          (keydown.enter)="app.onTopbarUserMenuButtonClick($event)"
          tabindex="0">
          <i
            class="fa fa-user-circle"
            aria-hidden="true"
            style="font-size: 14px; vertical-align: text-top"></i>
          Login
        </a>
      }
      @if (authenticated) {
        <a
          href="#"
          class="profile-menu-button"
          (click)="app.onTopbarUserMenuButtonClick($event)"
          (keydown.enter)="app.onTopbarUserMenuButtonClick($event)"
          tabindex="0">
          <i
            class="fa fa-user-circle"
            aria-hidden="true"
            style="font-size: 14px; vertical-align: text-top"></i>
          Welcome: {{ LoggedInUserName }}
        </a>
      }
      <ul
        class="layout-profile-menu fadeInDown"
        [ngClass]="{ 'layout-profile-menu-active': app.topbarUserMenuActive }"
        (click)="app.onTopbarUserMenuClick($event)"
        (keydown.enter)="app.onTopbarUserMenuClick($event)"
        tabindex="0">
        @if (!authenticated) {
          <li role="menuitem">
            <a
              href="#"
              class="ripplelink"
              (click)="login()"
              (keydown.enter)="login()"
              tabindex="0">
              <i class="fa fa-sign-in"></i>
              <span>Login</span>
            </a>
          </li>
        }
        @if (authenticated) {
          <li role="menuitem">
            <a
              href="#"
              class="ripplelink"
              (click)="logout()"
              (keydown.enter)="logout()"
              tabindex="0">
              <i class="fa fa-sign-out"></i>
              <span>Logout</span>
            </a>
          </li>
        }
      </ul>
    </div>
  </div>
</div>
